module.exports = function (cb, apiEndpoint) {
    var $page = $('#landing-page-with-search');
    var endpointUrl = URI(/icfapi/ + apiEndpoint);
    var browserUrl = URI(window.location.toString());

    var landingPageId;

    if ($page.attr('class').indexOf('award') != -1) {
      landingPageId = $page.data('awardLandingPageId');
      endpointUrl.setQuery('awardLandingPageId', landingPageId);
    }

    if ($page.attr('class').indexOf('client') != -1) {
      landingPageId = $page.data('clientStoryLandingPageId');
      endpointUrl.setQuery('clientStoryLandingPageId', landingPageId);
    }

    if ($page.attr('class').indexOf('event') != -1) {
      landingPageId = $page.data('eventLandingPageId');
      endpointUrl.setQuery('eventLandingPageId', landingPageId);
    }

    if ($page.attr('class').indexOf('news') != -1) {
      landingPageId = $page.data('newsLandingPageId');
      endpointUrl.setQuery('newsLandingPageId', landingPageId);
      if (window.column) {
          endpointUrl.setQuery('column', window.column);
      }      
    }

    if ($page.attr('class').indexOf('person') != -1) {
      landingPageId = $page.data('personIndexPageId');
      endpointUrl.setQuery('contextItemId', landingPageId);
    }

    if (window.rootInsightItemId && window.rootInsightItemId.length) {
        endpointUrl.setQuery("contextItemId", window.rootInsightItemId);
    }

    if (window.contentLabels && window.contentLabels.length) {
        var joinedContentLabels = window.contentLabels.join('|');

        if (joinedContentLabels.length) {
            endpointUrl.setQuery('types', joinedContentLabels);
            browserUrl.setQuery('types', joinedContentLabels);
        }
    }
    else {
        browserUrl.removeQuery('types');
    }

    if (window.topics && window.topics.length) {
        var joinedTopics = window.topics.join('|');

        if (joinedTopics.length) {
            endpointUrl.setQuery("topics", joinedTopics);
            browserUrl.setQuery('topics', joinedTopics);
        }
    }
    else {
        browserUrl.removeQuery('topics');
    }

    if (window.regions && window.regions.length) {
        var joinedRegions = window.regions.join('|');

        if (joinedRegions.length) {
            endpointUrl.setQuery("regions", joinedRegions);
            browserUrl.setQuery("regions", joinedRegions);
        }
    }
    else {
        browserUrl.removeQuery('regions');
    }

    if (window.page > 1) {
        endpointUrl.setQuery('page', window.page);
        browserUrl.setQuery('page', window.page);
    }
    else {
        endpointUrl.removeQuery('page');
        browserUrl.removeQuery('page');
    }

    if (window.pastevents == true) {
      endpointUrl.setQuery('pastevents', true);
      browserUrl.setQuery('pastevents', true);
    }
    else {
        browserUrl.removeQuery('pastevents');
    }
       
    if (window.topicMatchType && window.topicMatchType.length) {
        endpointUrl.setQuery("topicmatchtype", window.topicMatchType);
        browserUrl.setQuery("topicmatchtype", window.topicMatchType);
    }
    else {
        browserUrl.removeQuery('topicmatchtype');
    }

    if($($page).attr('class').indexOf('landing--filtered') != -1) {
      history.replaceState({}, '', browserUrl.toString());
  
      $.ajax({
          url: endpointUrl.toString(),
          success: function (result) {
              if (cb) {
                  cb(result);
              }
          },
          error: function (xhr, status, error) {
              return { 'error': error };
          }
      });
    }
    else if ($page.attr('class').indexOf('award') != -1) {
      window.location = browserUrl.toString();
    }
    else {
      history.replaceState({}, '', browserUrl.toString());

      $.ajax({
          url: endpointUrl.toString(),
          success: function (result) {
              if (cb) {
                  cb(result);
              }
          }
      });
    }
};